import React, {Component} from 'react';
import './AuthStartScreen.css';
import LoadingSpinner from "../Common/LoadingSpinner";
import {Redirect} from 'react-router-dom';
import axios from 'axios';
import SessionHelper from "../System/SessionHelper";

export default class AuthStartScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectTarget: null
        };
    }

    componentDidMount() {
        axios.get('/status')
            .then((res) => {
                let data = res.data;

                if (data.logged_in) {
                    this.ok = true;
                }

                SessionHelper.handleData(data);
            })
            .catch((err) => {
                console.error('Auth status GET, error caught:', err);
            })
            .then(() => {
                if (this.ok) {
                    this.setState({
                        redirectTarget: "/start"
                    });
                } else {
                    this.setState({
                        redirectTarget: "/inloggen"
                    });
                }
            })
    }

    render() {
        if (this.state.redirectTarget) {
            return <Redirect to={this.state.redirectTarget}/>
        }

        return (
            <div className={"AuthStartScreen"}>
                <LoadingSpinner/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthStartScreen.js